<template>
  <div>
    <sirui-table
      ref="siruiTable"
      :loading="load"
      :data="data"
      :paging="true"
      :setting="false"
      :customVisible="false"
      :columns="columnListDefault"
      height="200"
      class="marginTop"
    >
      <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnListDefault"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
      </vxe-table-column>
    </sirui-table>
  </div>
</template>

<script>
  export default {
    name: 'repairProject',
    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        load: false,
        columnListDefault: [
          {
            field: 'projectNo',
            title: '维修项目编号',
            visible: true,
          },
          {
            field: 'typeStr',
            title: '维修类型',
            visible: true,
          },
          {
            field: 'location',
            title: '维修地点',
            visible: true,
          },
          {
            field: 'content',
            title: '维修内容',
            visible: true,
          },
          {
            field: 'estimatedCost',
            title: '维修预估费用（元）',
            visible: true,
          },
          {
            field: 'plan',
            title: '维修方案',
            visible: true,
          },
          {
            field: 'actualCost',
            title: '维修实际费用（元）',
            visible: true,
          },
          {
            field: 'completeDate',
            title: '完工日期',
            visible: true,
          },
        ],
      };
    },
  };
</script>

<style scoped>
  .marginTop {
    margin-top: -46px;
  }
</style>
